import { GET_NETBANKING_CONFIGURATIONS_FAILURE, GET_NETBANKING_CONFIGURATIONS_SUCCESS, PAYMENT_USING_NETBANKING_SUCCESS, PAYMENT_USING_NETBANKING_FAILURE, RESET_PAYMENT_STATUS, GET_NETBANKING_CONFIGURATIONS, PAYMENT_USING_NETBANKING, GET_PAYTM_TOKEN_CALL, GET_PAYTM_TOKEN_SUCCESS, GET_PAYTM_TOKEN_FAILED, PAYMENT_USING_PHONEPE, PAYMENT_USING_PHONEPE_SUCCESS, PAYMENT_USING_PHONEPE_FAILURE, PHONEPE_STATUS_CHECK, PHONEPE_STATUS_CHECK_FAILURE, PHONEPE_STATUS_CHECK_SUCCESS, PAYTM_STATUS_CHECK, PAYTM_STATUS_CHECK_SUCCESS, PAYTM_STATUS_CHECK_FAILURE, FETCH_OTHER_WALLETS_LIST, FETCH_OTHER_WALLETS_LIST_SUCCESS, FETCH_OTHER_WALLETS_LIST_FAILURE, PAYMENT_USING_GOOGLEPAY, PAYMENT_USING_GOOGLEPAY_SUCCESS, PAYMENT_USING_GOOGLEPAY_FAILURE, DELETE_SAVED_CARD_FAILURE, DELETE_SAVED_CARD_SUCCESS, DELETE_SAVED_CARD, PAYMENT_FOR_ADDHOPE, PAYMENT_FOR_ADDHOPE_FAILURE, PAYMENT_FOR_ADDHOPE_SUCCESS, PAYMENT_FOR_GIFTCARD, PAYMENT_FOR_GIFTCARD_SUCCESS, PAYMENT_FOR_GIFTCARD_FAILURE, GLOBALPAYMENTS_GENERATE_TOKEND_SUCCESS, GLOBALPAYMENTS_GENERATE_TOKEND_FAILURE, GLOBALPAYMENTS_GENERATE_TOKEN, GLOBALPAYMENTS_INITIATE_PAYMENT_CALL, GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_SUCCESS, GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_FAILED, GLOBALPAYMENTS_VALIDATE_ADDRESSS_SUCCESS, GLOBALPAYMENTS_VALIDATE_ADDRESSS_FAILURE, GLOBALPAYMENTS_VALIDATE_ADDRESSS, GLOBALPAYMENT_SAVE_CARD, GLOBALPAYMENT_SAVE_CARD_SUCCESS, GLOBALPAYMENT_SAVE_CARD_FAILUR, GLOBALPAYMENT_IS_STORE_3DS_ENABLED, GLOBALPAYMENT_IS_STORE_3DS_ENABLED_SUCCESS, GLOBALPAYMENT_IS_STORE_3DS_ENABLED_FAILURE, GLOBALPAYMENT_VERIFY_CARD, GLOBALPAYMENT_VERIFY_CARD_SUCCESS, GLOBALPAYMENT_VERIFY_CARD_FAILURE, DGFT_CREDITCARD_GENERATE_TOKEN, DGFT_CREDITCARD_GENERATE_TOKEND_SUCCESS, DGFT_CREDITCARD_GENERATE_TOKEND_FAILURE, DGFT_APPLEPAY_GENERATE_TOKEN, DGFT_APPLEPAY_GENERATE_TOKEN_SUCCESS, DGFT_APPLEPAY_GENERATE_TOKEN_FAILURE, PAYMENT_REQUESTED_CALL, PAYMENT_REQUESTED_SUCCESS, PAYMENT_REQUESTED_FAILED, DGFT_PAYMENT_AUTHORIZE_CALL, DGFT_PAYMENT_AUTHORIZE_SUCCESS, DGFT_PAYMENT_AUTHORIZE_FAILED, GIFTCARD_BALANCE_CALL, GIFTCARD_BALANCE_SUCCESS, GIFTCARD_BALANCE_FAILED, DGFT_GET_SAVED_CARD_CALL, DGFT_GET_SAVED_CARD_SUCCESS, DGFT_GET_SAVED_CARD_FAILED, DGFT_DELETE_SAVED_CARD_CALL, DGFT_DELETE_SAVED_CARD_SUCCESS, DGFT_DELETE_SAVED_CARD_FAILED, } from '../../constants';
const initialState = {
    configuration: {},
    response: {},
    netbankingPaymentFailed: false,
    netbankingConfigurationError: false,
    isNetbankPaymentLoading: false,
    isGetNetBankLoading: false,
    isPaytmPaymentLoading: false,
    phonePeStatusData: null,
    phonePeStatusMaxCallsCount: 0,
    isPhonePeStatusLoading: false,
    isPhonePayLoading: false,
    paytmStatusData: null,
    paytmStatusMaxCallsCount: 0,
    isPaytmStatusLoading: false,
    isWalletsListLoading: false,
    isGooglePayLoading: false,
    error: false,
    isLoading: false,
    isPaygateStatusLoading: false,
    addHopePayResponse: null,
    globalPaymentsGeneratedAccessToken: '',
    globalPaymentsInitiatePaymentResponse: {},
    globalPaymentValidateAdressResponse: {},
    globalPaymentSaveCard: '',
    gloablPaymentIsStore3dsEnabled: {},
    globalPaymentVerifyCard: {},
    globalpaymentsCreditCardPlaceOrderLoader: false,
    dgftCreditCardGenerateTokenResponse: {},
    dgftApplePayGenerateTokenResponse: {},
    paymentRequestedResponse: {},
    dgftPaymentAuthorizeResponse: {},
    giftCardbalanceResponse: {},
    savedCardResponse: {},
    dgftDeleteSavedCardDetails: {},
    japanPaymentsCreditCardPlaceOrderLoader: false,
};
const paymentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_NETBANKING_CONFIGURATIONS:
            return {
                ...state,
                isGetNetBankLoading: true,
            };
        case GET_NETBANKING_CONFIGURATIONS_SUCCESS:
            return {
                ...state,
                configuration: action.response,
                netbankingConfigurationError: false,
                isGetNetBankLoading: false,
            };
        case GET_NETBANKING_CONFIGURATIONS_FAILURE:
            return {
                ...state,
                netbankingConfigurationError: true,
                isGetNetBankLoading: false,
            };
        case PAYMENT_USING_NETBANKING:
            return {
                ...state,
                isNetbankPaymentLoading: true,
            };
        case PAYMENT_USING_NETBANKING_SUCCESS:
            return {
                ...state,
                response: action.response,
                netbankingPaymentFailed: false,
                isNetbankPaymentLoading: false,
            };
        case PAYMENT_USING_NETBANKING_FAILURE:
            return {
                ...state,
                netbankingPaymentFailed: true,
                isNetbankPaymentLoading: false,
            };
        case RESET_PAYMENT_STATUS:
            return {
                ...state,
                response: {},
                netbankingPaymentFailed: false,
                netbankingConfigurationError: false,
                isNetbankPaymentLoading: false,
                isGetNetBankLoading: false,
                phonePeStatusData: null,
                phonePeStatusMaxCallsCount: 0,
                paytmStatusData: null,
                paytmStatusMaxCallsCount: 0,
                addHopePayResponse: null,
                isPaygateStatusLoading: false,
                globalPaymentsGeneratedAccessToken: '',
                globalPaymentsInitiatePaymentResponse: {},
                globalPaymentValidateAdressResponse: {},
                globalPaymentSaveCard: '',
                giftCardPayResponse: null,
                paymentRequestedResponse: {},
                dgftCreditCardGenerateTokenResponse: {},
                dgftApplePayGenerateTokenResponse: {},
                dgftPaymentAuthorizeResponse: {},
            };
        case GET_PAYTM_TOKEN_CALL:
            return {
                ...state,
                isPaytmPaymentLoading: true,
            };
        case GET_PAYTM_TOKEN_SUCCESS:
            return {
                ...state,
                isPaytmPaymentLoading: false,
                response: action.response,
            };
        case GET_PAYTM_TOKEN_FAILED:
            return {
                ...state,
                isPaytmPaymentLoading: false,
            };
        case PAYMENT_USING_PHONEPE:
            return {
                ...state,
                isPhonePayLoading: true,
            };
        case PAYMENT_USING_PHONEPE_SUCCESS:
            return {
                ...state,
                isPhonePayLoading: false,
                response: action.response,
            };
        case PAYMENT_USING_PHONEPE_FAILURE:
            return {
                ...state,
                isPhonePayLoading: false,
            };
        case PAYMENT_USING_GOOGLEPAY:
            return {
                ...state,
                isGooglePayLoading: true,
            };
        case PAYMENT_USING_GOOGLEPAY_SUCCESS:
            return {
                ...state,
                isGooglePayLoading: false,
                response: action.response,
            };
        case PAYMENT_USING_GOOGLEPAY_FAILURE:
            return {
                ...state,
                isGooglePayLoading: false,
            };
        case PHONEPE_STATUS_CHECK:
            return {
                ...state,
                isPhonePeStatusLoading: true,
                phonePeStatusMaxCallsCount: action?.phonePeStatusMaxCallsCount || 0,
            };
        case PHONEPE_STATUS_CHECK_SUCCESS:
            return {
                ...state,
                isPhonePeStatusLoading: false,
                phonePeStatusData: action.response,
            };
        case PHONEPE_STATUS_CHECK_FAILURE:
            return {
                ...state,
                isPhonePeStatusLoading: false,
            };
        case PAYTM_STATUS_CHECK:
            return {
                ...state,
                isPaytmStatusLoading: true,
                paytmStatusMaxCallsCount: action?.paytmStatusMaxCallsCount || 0,
            };
        case PAYTM_STATUS_CHECK_SUCCESS:
        case PAYTM_STATUS_CHECK_FAILURE:
            return {
                ...state,
                isPaytmStatusLoading: false,
                paytmStatusData: action.response,
            };
        case FETCH_OTHER_WALLETS_LIST:
            return {
                ...state,
                isWalletsListLoading: true,
            };
        case FETCH_OTHER_WALLETS_LIST_SUCCESS:
            return {
                ...state,
                isWalletsListLoading: false,
                otherWallets: action.response,
            };
        case FETCH_OTHER_WALLETS_LIST_FAILURE:
            return {
                ...state,
                isWalletsListLoading: false,
            };
        case DELETE_SAVED_CARD:
        case DGFT_APPLEPAY_GENERATE_TOKEN:
        case GLOBALPAYMENT_SAVE_CARD:
        case GLOBALPAYMENT_VERIFY_CARD:
            return {
                ...state,
                error: false,
                isLoading: true,
            };
        case DELETE_SAVED_CARD_FAILURE:
            return {
                ...state,
                error: true,
                isLoading: false,
            };
        case DELETE_SAVED_CARD_SUCCESS:
            return {
                ...state,
                error: false,
                isLoading: false,
            };
        case PAYMENT_FOR_ADDHOPE:
        case PAYMENT_FOR_GIFTCARD:
            return {
                ...state,
                error: false,
                isPaygateStatusLoading: true,
            };
        case PAYMENT_FOR_ADDHOPE_FAILURE:
            return {
                ...state,
                error: true,
                isPaygateStatusLoading: false,
                addHopePayResponse: action.response,
            };
        case PAYMENT_FOR_ADDHOPE_SUCCESS:
            return {
                ...state,
                error: false,
                isPaygateStatusLoading: false,
                addHopePayResponse: action.response,
            };
        case PAYMENT_FOR_GIFTCARD_FAILURE:
            return {
                ...state,
                error: true,
                isPaygateStatusLoading: false,
                giftCardPayResponse: action.response,
            };
        case PAYMENT_FOR_GIFTCARD_SUCCESS:
            return {
                ...state,
                error: false,
                isPaygateStatusLoading: false,
                giftCardPayResponse: action.response,
            };
        case GLOBALPAYMENTS_GENERATE_TOKEN:
        case GLOBALPAYMENTS_INITIATE_PAYMENT_CALL:
        case GLOBALPAYMENTS_VALIDATE_ADDRESSS:
        case GLOBALPAYMENT_IS_STORE_3DS_ENABLED:
            return {
                ...state,
                error: false,
                isLoading: true,
                globalpaymentsCreditCardPlaceOrderLoader: true,
            };
        case GLOBALPAYMENTS_GENERATE_TOKEND_FAILURE:
            return {
                ...state,
                error: true,
                isLoading: false,
                globalpaymentsCreditCardPlaceOrderLoader: false,
            };
        case GLOBALPAYMENTS_GENERATE_TOKEND_SUCCESS:
            return {
                ...state,
                error: false,
                isLoading: false,
                globalPaymentsGeneratedAccessToken: action.response,
                globalpaymentsCreditCardPlaceOrderLoader: false,
            };
        case GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_SUCCESS:
            return {
                ...state,
                error: false,
                isLoading: false,
                globalPaymentsInitiatePaymentResponse: action.response,
                globalpaymentsCreditCardPlaceOrderLoader: false,
            };
        case GLOBALPAYMENTS_INITIATE_PAYMENT_CALL_FAILED:
            return {
                ...state,
                error: true,
                isLoading: false,
                globalPaymentsInitiatePaymentResponse: {},
                globalpaymentsCreditCardPlaceOrderLoader: false,
            };
        case GLOBALPAYMENTS_VALIDATE_ADDRESSS_SUCCESS:
            return {
                ...state,
                error: false,
                isLoading: false,
                globalPaymentValidateAdressResponse: action.response,
                globalpaymentsCreditCardPlaceOrderLoader: false,
            };
        case GLOBALPAYMENTS_VALIDATE_ADDRESSS_FAILURE:
            return {
                ...state,
                error: true,
                isLoading: false,
                globalPaymentValidateAdressResponse: {},
                globalpaymentsCreditCardPlaceOrderLoader: false,
            };
        case GLOBALPAYMENT_SAVE_CARD_SUCCESS:
            return {
                ...state,
                error: false,
                isLoading: false,
                globalPaymentSaveCard: action.response,
            };
        case GLOBALPAYMENT_SAVE_CARD_FAILUR:
            return {
                ...state,
                error: true,
                isLoading: false,
                globalPaymentSaveCard: action.response,
            };
        case GLOBALPAYMENT_IS_STORE_3DS_ENABLED_SUCCESS:
            return {
                ...state,
                error: false,
                isLoading: false,
                gloablPaymentIsStore3dsEnabled: action.response,
                globalpaymentsCreditCardPlaceOrderLoader: false,
            };
        case GLOBALPAYMENT_IS_STORE_3DS_ENABLED_FAILURE:
            return {
                ...state,
                error: true,
                isLoading: false,
                gloablPaymentIsStore3dsEnabled: action.response,
                globalpaymentsCreditCardPlaceOrderLoader: false,
            };
        case GLOBALPAYMENT_VERIFY_CARD_SUCCESS:
            return {
                ...state,
                error: false,
                isLoading: false,
                globalPaymentVerifyCard: action.response,
            };
        case GLOBALPAYMENT_VERIFY_CARD_FAILURE:
            return {
                ...state,
                error: true,
                isLoading: false,
                globalPaymentVerifyCard: action.response,
            };
        case DGFT_CREDITCARD_GENERATE_TOKEND_SUCCESS:
            return {
                ...state,
                error: false,
                isLoading: false,
                dgftCreditCardGenerateTokenResponse: action.response,
                japanPaymentsCreditCardPlaceOrderLoader: false,
            };
        case DGFT_CREDITCARD_GENERATE_TOKEND_FAILURE:
            return {
                ...state,
                error: true,
                isLoading: false,
                dgftCreditCardGenerateTokenResponse: {},
                japanPaymentsCreditCardPlaceOrderLoader: false,
            };
        case DGFT_APPLEPAY_GENERATE_TOKEN_SUCCESS:
            return {
                ...state,
                error: false,
                isLoading: false,
                dgftApplePayGenerateTokenResponse: action.response,
            };
        case DGFT_APPLEPAY_GENERATE_TOKEN_FAILURE:
            return {
                ...state,
                error: true,
                isLoading: false,
                dgftApplePayGenerateTokenResponse: {},
            };
        case DGFT_CREDITCARD_GENERATE_TOKEN:
            return {
                ...state,
                error: false,
                isLoading: true,
                japanPaymentsCreditCardPlaceOrderLoader: true,
            };
        case DGFT_PAYMENT_AUTHORIZE_CALL:
        case PAYMENT_REQUESTED_CALL:
        case DGFT_GET_SAVED_CARD_CALL:
        case DGFT_DELETE_SAVED_CARD_CALL:
            return {
                ...state,
                isLoading: true,
                error: false,
                japanPaymentsCreditCardPlaceOrderLoader: true,
            };
        case DGFT_PAYMENT_AUTHORIZE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                error: false,
                dgftPaymentAuthorizeResponse: action.response,
                japanPaymentsCreditCardPlaceOrderLoader: false,
            };
        case DGFT_PAYMENT_AUTHORIZE_FAILED:
            return {
                ...state,
                isLoading: false,
                error: true,
                dgftPaymentAuthorizeResponse: {},
                japanPaymentsCreditCardPlaceOrderLoader: false,
            };
        case PAYMENT_REQUESTED_SUCCESS:
            return {
                ...state,
                isLoading: false,
                error: false,
                paymentRequestedResponse: action.response,
                japanPaymentsCreditCardPlaceOrderLoader: false,
            };
        case PAYMENT_REQUESTED_FAILED:
            return {
                ...state,
                isLoading: false,
                error: true,
                paymentRequestedResponse: {},
                japanPaymentsCreditCardPlaceOrderLoader: false,
            };
        case GIFTCARD_BALANCE_CALL:
            return {
                ...state,
                isLoading: true,
            };
        case GIFTCARD_BALANCE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                giftCardbalanceResponse: action.response,
            };
        case GIFTCARD_BALANCE_FAILED:
            return {
                ...state,
                isLoading: false,
                giftCardbalanceResponse: {},
            };
        case DGFT_GET_SAVED_CARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                savedCardResponse: action.response,
                japanPaymentsCreditCardPlaceOrderLoader: false,
            };
        case DGFT_GET_SAVED_CARD_FAILED:
            return {
                ...state,
                isLoading: false,
                savedCardResponse: {},
                japanPaymentsCreditCardPlaceOrderLoader: false,
            };
        case DGFT_DELETE_SAVED_CARD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                dgftDeleteSavedCardDetails: action.response,
                japanPaymentsCreditCardPlaceOrderLoader: false,
            };
        case DGFT_DELETE_SAVED_CARD_FAILED:
            return {
                ...state,
                isLoading: false,
                dgftDeleteSavedCardDetails: {},
                japanPaymentsCreditCardPlaceOrderLoader: false,
            };
        default:
            return state;
    }
};
export default paymentsReducer;
